/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Policy_Number_LabelInputs */

const en_claims_policy_number_label = /** @type {(inputs: Claims_Policy_Number_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Policy Number`)
};

const fr_claims_policy_number_label = /** @type {(inputs: Claims_Policy_Number_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de police`)
};

/**
* | output |
* | --- |
* | "Policy Number" |
*
* @param {Claims_Policy_Number_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_policy_number_label = /** @type {((inputs?: Claims_Policy_Number_LabelInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Policy_Number_LabelInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_policy_number_label(inputs)
	return fr_claims_policy_number_label(inputs)
});